var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":_vm.globalTxt.title}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }